<div class="billing-switch" role="group" [attr.aria-label]="'subscription.billingCycle' | translate">
  <button type="button" [class.active]="billingPeriod === planSubscriptionPeriodEnum.MONTH"
    [attr.aria-pressed]="billingPeriod === planSubscriptionPeriodEnum.MONTH"
    (click)="changeBillingPeriod(planSubscriptionPeriodEnum.MONTH)">
    {{ 'subscription.monthly' | translate }}
  </button>
  <button type="button" [class.active]="billingPeriod === planSubscriptionPeriodEnum.YEAR"
    [attr.aria-pressed]="billingPeriod === planSubscriptionPeriodEnum.YEAR"
    (click)="changeBillingPeriod(planSubscriptionPeriodEnum.YEAR)">
    {{ 'subscription.yearly' | translate }}
  </button>
</div>
<div *ngIf="plansLoading" class="dataLoading">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>
<div *ngIf="loadError" role="alert">
  <p>{{ 'subscription.loadError' | translate }}</p>
  <button type="button" (click)="loadPlans()">{{ 'subscription.retry' | translate }}</button>
</div>
<empty-state *ngIf="!plansLoading && !loadError && !availablePlans.length">
  <!-- {{ 'general.No Data Found' | translate }} -->
</empty-state>
<div class="plans" [attr.aria-busy]="plansLoading">
  <article class="plan" *ngFor="let plan of availablePlans">
    <div class="plan-period">{{ plan.name }}</div>
    <h3 class="plan-price">
      <ng-container *ngIf="plan.price === 0; else paidPrice">{{ 'subscription.free' | translate }}</ng-container>
      <ng-template #paidPrice>{{ plan.price }} <span class="currency"><img
            src="assets/images/icons/subscription-riyal.svg"
            [alt]="'subscription.currency' | translate"></span></ng-template>
    </h3>
    <p class="features-label" *ngIf="plan.benefits.length">{{ 'subscription.includes' | translate }}</p>
    <ul>
      <li *ngFor="let benefit of plan.benefits"><img class="feature-check"
          src="assets/images/icons/subscription-check.svg" alt="" aria-hidden="true"><span>{{ benefit }}</span></li>
    </ul>
    <button mat-raised-button color="primary" class="select-plan" [disabled]="loading || plansLoading"
      (click)="selectPlan.emit({ planId: plan.planId, billingPeriod: plan.planSubscriptionPeriodEnum,isFree:plan.isFree,forRenew:false })"
      [attr.aria-label]="'subscription.selectPlanLabel' | translate: { name: plan.name }">{{ 'subscription.selectPlan' |
      translate }}</button>
  </article>
</div>
